import { CardShell } from '@/src/components/global/card-shell/CardShell'
import { VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import CardScore from '@/src/components/global/card-score/CardScore'

interface VendorSummaryCardProps {
  userId: string
  averageScore: number | null | undefined
  countDiagnoses: number
  onClick: (userId: string) => void
}

const VendorSummaryCard = ({
  userId,
  averageScore,
  countDiagnoses,
  onClick,
}: VendorSummaryCardProps) => {
  const { t } = useTranslation('common')
  return (
    <button type="button" data-testid="vendor-summary-card-button" onClick={() => onClick(userId)}>
      <CardShell className="p-4">
        <div className="flex gap-3 items-center">
          <div className="p-2 rounded-full bg-on-brand-quiet">
            <VpIcon name="user" />
          </div>
          <div className="flex-1 flex flex-col gap-1">
            <span className="font-semibold">{userId}</span>
            <span
              data-testid="vendor-summary-card-count-diagnoses"
              className="text-sm text-content-quiet"
            >
              {t('pages.my-team.vendors.count-diagnoses', { count: countDiagnoses })}
            </span>
          </div>
          <CardScore size="xl" score={averageScore} />
        </div>
      </CardShell>
    </button>
  )
}

export default VendorSummaryCard
